import closest from '@mailobj-browser/front/js/selectors/closest.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import { opener } from '#utilities/js/lightboxes/lightbox.js'
import inserted from '@mailobj-browser/front/js/tree/inserted.js'

const forms = new Set()
let counter = 0

export const target = submit => {
  const { ownerDocument } = submit
  const { body } = ownerDocument

  queueMicrotask(async () => {
    await inserted(submit, body)
    const element = opener(closest('aside > *', submit))

    if (element) {
      for (const form of forms) {
        if (form.contains(element)) {
          const { id } = form

          submit.setAttribute('form', id)
          break
        }
      }
    }
  })
}

export default form => {
  form.id = `ea-form${counter}`
  forms.add(form)
  counter += 1

  queueMicrotask(async () => {
    await removed(form)
    forms.delete(form)
  })
}
